const PLAN_CART_CHECKOUT_TRACKING_EVENTS = {
  planCartCheckout: {
    clicked: true,
    viewed: true,
    error: true,
  },
};

export default PLAN_CART_CHECKOUT_TRACKING_EVENTS;
